module.exports = __webpack_public_path__ + "static/img/22.90cd9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/customization/22.png
// module id = 13bf
// module chunks = 1